import { useCallback, useMemo, useState } from 'react';

export function useSemicontrolledState<T>(
  externalState: T,
  externalSetState?: (newState: T) => void,
): [T, (setState: T) => void] {
  const [backupState, setBackupState] = useState<T>(externalState);

  const state = useMemo(
    () => (externalSetState ? externalState : backupState),
    [externalState, backupState, externalSetState],
  );

  const setState = useCallback(
    (newState: T) => {
      if (externalSetState !== undefined) {
        externalSetState(newState);
      } else {
        setBackupState(newState);
      }
    },
    [externalSetState, setBackupState],
  );

  return [state, setState];
}
